// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__L8k+w","ldsRipple":"Loader_ldsRipple__7+bJS"};